import { FC, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { EPriceTime, PricedisplayType } from '@/shared/types';
import {
  DatePicker,
  Wrapper,
  Form,
  Button,
  Modal,
  FormTitle,
  Tabs,
  Select,
  Checkbox,
  useBreadcrumbRoutes,
} from '@maxtropy/components';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { Space, Upload as AntdUpload, Popconfirm } from 'antd';
import TimeSelect from './components/TimeSelect';
import styles from './index.module.scss';
import {
  getDateArray,
  findTimesById,
  copyDetailListFromSourceToTargets,
  checkTimeSlotConflict,
  batchMediumId,
  disabled7DaysDate,
  getNearestSaturday,
  mergeMediumOrgZone,
  clearDataByids,
  editTimeByIds,
  dateToData,
} from './util';
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { formatDateTimeRange, parsePeriodTimes } from './components/EpriceTime/utils';
import { useNavigate, useParams } from 'react-router-dom';
import {
  apiV2EnergyConsumptionAdminListPost,
  apiV2EnergyConsumptionPlanAddPost,
  apiV2EnergyConsumptionPlanDetailPost,
  apiV2EnergyConsumptionPlanGetStaffOrgMappingPost,
  apiV2EnergyConsumptionPlanGetUsedTimePost,
  apiV2EnergyConsumptionPlanUpdatePost,
} from '@maxtropy/device-customer-apis-v2';
import { IdExpriceTime } from './type';
import classNames from 'classnames';
const RangePicker = DatePicker.RangePicker;

const UsePlanRequistion: FC<{ isView?: boolean }> = ({ isView = false }) => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const breadcrumbRoutes = useBreadcrumbRoutes(); //面包屑
  const initDate = getDateArray(getNearestSaturday(), 7);
  const [batchOp, setBatchOp] = useState<boolean>(false); // 是否批量操作
  const [data, setData] = useState<any>([]); // 完整数据
  const [DateRange, setDateRange] = useState<string[]>(initDate); //datepicker选择的日期范围
  // 添加数据暂存 Map，key 为日期范围字符串，value 为对应的数据
  const dataCache = useRef<Map<string, any>>(new Map());
  const [dateSelectIndex, setDateSelectIndex] = useState<string[]>([]); // 选择的日期索引
  const [modalVisible, setModalVisible] = useState<boolean>(false); // 编辑时间弹窗显示控制
  const [mediumType, setMediumType] = useState<number>(1); // 当前选择的能源介质类型
  const [batchType, setBatchType] = useState<any>([]); // 批量操作选择的能源介质类型
  const [isCopy, setIsCopy] = useState<boolean>(false);
  const [ExprieceTimeList, setExprieceTimeList] = useState<IdExpriceTime>({
    ids: [],
    times: [],
    displayType: PricedisplayType.HOUR,
  }); // 当前编辑的时间段信息
  const [copySelectMedium, setCopySelectMedium] = useState<number[]>([]); // 复制操作时选择的能源介质
  const [disabledDates, setDisabledDates] = useState<EPriceTime[]>([]); // 存储不可选择的日期
  const [form] = Form.useForm();
  const mediumRef = useRef<any>([]);
  const timeSlotCount = useRef<Map<string, number>>(new Map()); // 用于存储每个时间槽的数量
  const [stickyKeys, setStickyKeys] = useState<Set<string>>(new Set()); // 需要定位设置为sticky的key集合
  const [limitTime, setLimitTime] = useState<boolean>(true);
  const conflictedTime = useRef<Map<string, any>>(new Map()); //存储冲突的时间段
  const routes = useMemo(() => {
    return [{ name: `${id ? (isView ? '查看' : '编辑') : '新建'}用能计划申请` }];
  }, [isView, id]);

  useEffect(() => {
    if (!id) {
      Promise.all([apiV2EnergyConsumptionPlanGetStaffOrgMappingPost({}), apiV2EnergyConsumptionAdminListPost({})]).then(
        ([orgZoneResponse, mediumResponse]) => {
          const merged = mergeMediumOrgZone(mediumResponse.list ?? [], [orgZoneResponse], initDate);
          mediumRef.current = mediumResponse.list;
          setData(merged);
          // 移动到此处：在数据初始化后设置
          form.setFieldValue('date', [
            dayjs(merged[0]?.ownerOrgInfoVoList[0]?.areaInfoVoList[0]?.timeDetailVoList[0]?.date),
            dayjs(merged[0]?.ownerOrgInfoVoList[0]?.areaInfoVoList[0]?.timeDetailVoList[6]?.date),
          ]);
          setLimitTime(orgZoneResponse?.limitTime === undefined ? true : orgZoneResponse.limitTime);
          setDateRange(
            merged[0]?.ownerOrgInfoVoList[0]?.areaInfoVoList[0]?.timeDetailVoList.map((item: any) => item.date) || []
          );
        }
      );
    } else {
      apiV2EnergyConsumptionPlanDetailPost({ id }).then((response: any) => {
        setData(response.energyConsumptionPlanOfMediumList);
        // 移动到此处：在数据初始化后设置
        form.setFieldValue('date', [
          dayjs(
            response.energyConsumptionPlanOfMediumList[0]?.ownerOrgInfoVoList[0]?.areaInfoVoList[0]?.timeDetailVoList[0]
              ?.date
          ),
          dayjs(
            response.energyConsumptionPlanOfMediumList[0]?.ownerOrgInfoVoList[0]?.areaInfoVoList[0]?.timeDetailVoList[6]
              ?.date
          ),
        ]);
        setDateRange(
          response.energyConsumptionPlanOfMediumList[0]?.ownerOrgInfoVoList[0]?.areaInfoVoList[0]?.timeDetailVoList.map(
            (item: any) => item.date
          ) || []
        );
        mediumRef.current = response.energyConsumptionPlanOfMediumList.map((item: any) => ({
          energyMediumId: item.mediumId,
          energyMediumName: item.mediumName,
        }));
      });
    }
  }, [id]);

  useLayoutEffect(() => {
    const newStickyKeys = new Set<string>();
    data
      .filter((medium: any) => medium.mediumId === mediumType)
      .forEach((medium: any) =>
        medium.ownerOrgInfoVoList.forEach((dept: any) =>
          dept.areaInfoVoList.forEach((area: any) =>
            area.timeDetailVoList.forEach((date: any) => {
              timeSlotCount.current.set(
                `${mediumType}+${dept.ownerOrgId}+${area.areaId}+${date.date}`,
                date.detailList.length
              );
            })
          )
        )
      );
    timeSlotCount.current.forEach((el, key) => {
      if (el > 5) newStickyKeys.add(key);
    });
    setStickyKeys(() => newStickyKeys);
  }, [mediumType, data]);

  const dateChange = (date: Dayjs | (Dayjs | null)[] | null, dateString: string | string[]) => {
    const newDateRange = getDateArray(dateString[0], 7);
    const newKey = getDateRangeKey(newDateRange);

    // 切换日期时清除之前所有缓存，仅保留当前选择（不保留历史时段数据）
    dataCache.current.clear();

    // 生成新数据结构（保留媒体/组织结构，但清空所有 time slot）
    setData((prevData: any) => {
      const newData = dateToData(prevData, newDateRange);
      dataCache.current.set(newKey, newData);
      return newData;
    });

    setDateRange(newDateRange);
    // 清空选中状态
    setDateSelectIndex([]);
  };

  const clear = (ids: string[]) => {
    setData((prevData: any) => clearDataByids(prevData, ids));
    setExprieceTimeList({ ids: [], times: [], displayType: PricedisplayType.HOUR });
  };

  useEffect(() => {
    if (data && data.length > 0) {
      apiV2EnergyConsumptionPlanGetUsedTimePost({
        //data去除detailList
        energyConsumptionPlanOfMediumList: data.map((medium: any) => ({
          ...medium,
          ownerOrgInfoVoList: medium.ownerOrgInfoVoList.map((dept: any) => ({
            ...dept,
            areaInfoVoList: dept.areaInfoVoList.map((area: any) => ({
              ...area,
              timeDetailVoList: area.timeDetailVoList.map((date: any) => {
                return date.date;
              }),
            })),
          })),
        })),
        ...(id && !isView && { id: +id! }),
      }).then((response: any) => {
        response.energyConsumptionPlanOfMediumList.forEach((medium: any) => {
          medium.ownerOrgInfoVoList.forEach((dept: any) => {
            dept.areaInfoVoList.forEach((area: any) => {
              area.timeDetailVoList.forEach((date: any) => {
                conflictedTime.current.set(
                  `${medium.mediumId}+${dept.ownerOrgId}+${area.areaId}+${date.date}`,
                  date.detailList
                );
              });
            });
          });
        });
      });
    }
  }, [DateRange]);

  const parseTime = (id: string) => {
    const item = findTimesById(id, data);
    setExprieceTimeList({
      ids: [id],
      times: parsePeriodTimes(item?.times as string[], item?.displayType as unknown as PricedisplayType),
      displayType: item?.displayType as unknown as PricedisplayType,
    });
  };

  const editTime = (ids: string[]) => {
    if (batchOp) setExprieceTimeList(() => ({ ids: [], times: [], displayType: PricedisplayType.HOUR }));
    setData((prevData: any) => editTimeByIds(prevData, ids, ExprieceTimeList));
  };

  const checkTimeSlotConflictMerge = (ids: string[]) => {
    let temp: any = [];
    ids.forEach(id => {
      const { mergedTimeSlots, date } = checkTimeSlotConflict(id, data, conflictedTime.current);
      temp.push(
        parsePeriodTimes(
          mergedTimeSlots.map(range => {
            return formatDateTimeRange(range.startDateTime, range.endDateTime, date);
          }),
          ExprieceTimeList.displayType!
        )
      );
    });
    console.log('Disabled dates:', temp);
    !batchOp ? setDisabledDates(temp[0]) : setDisabledDates(temp.flat());
  };

  // 生成日期范围的唯一键
  const getDateRangeKey = (dates: string[]) => `${dates[0]}_${dates[dates.length - 1]}`;

  const submit = () => {
    // 保存当前数据到缓存
    const currentKey = getDateRangeKey(DateRange);
    dataCache.current.set(currentKey, data);

    // 遍历所有缓存的数据并分别提交
    const submitPromises = Array.from(dataCache.current.entries()).map(([dateKey, cachedData]) => {
      const params = {
        energyConsumptionPlanOfMediumList: cachedData,
        ...(id && { id: +id }),
      };
      return (id ? apiV2EnergyConsumptionPlanUpdatePost : apiV2EnergyConsumptionPlanAddPost)(params);
    });

    Promise.all(submitPromises)
      .then(() => {
        navigate('/energy/usage/application');
      })
      .catch(error => {
        const { errorMessage } = error?.cause;
        Modal.error({
          title: '用能计划冲突',
          width: 480,
          bodyStyle: { overflowY: 'auto', maxHeight: '400px' },
          content: (
            <Space direction="vertical" size={4}>
              {errorMessage.split('\n').map((line: string, index: number) => (
                <div key={index}>{line}</div>
              ))}
            </Space>
          ),
        });
      });
  };

  const updateDataByUpload = (newData: any) => {
    //将存在的mediumId的数据替换掉
    setData((prevData: any) => {
      prevData.forEach((medium: any, index: number) => {
        const newMedium = newData.find((newMedium: any) => newMedium.mediumId === medium.mediumId);
        if (newMedium) {
          prevData[index] = newMedium;
        }
      });
      return [...prevData];
    });
  };
  // 使用 useMemo 缓存过滤后的数据，避免每次渲染时重新过滤
  const filteredData = useMemo(() => {
    return data.filter((item: any) => item.mediumId === mediumType);
  }, [data, mediumType]);

  const TableHeader = (
    <div style={{ display: 'flex', gap: '4px', width: '100%' }}>
      <div className={styles.item} style={{ width: '190px' }}>
        供应部门
      </div>
      <div className={styles.item} style={{ width: '170px' }}>
        区域
      </div>
      <div style={{ flex: 1, display: 'flex', gap: '4px' }}>
        {DateRange.map((date, i) => (
          <div className={styles.item} style={{ flex: 1 }} key={i}>
            {date}
          </div>
        ))}
      </div>
    </div>
  );

  // 使用 useMemo 缓存 TableBody，避免每次切换时重渲染
  const TableBody = useMemo(
    () => (
      <div>
        {TableHeader}
        <div className={styles.tableContent}>
          {filteredData
            .map((medium: any) =>
              medium.ownerOrgInfoVoList.map((dept: any, deptIndex: number) => {
                const rowSpan = dept.areaInfoVoList.length;
                return dept.areaInfoVoList.map((area: any, areaIndex: number) => (
                  <div className={styles.tableRow} key={`${dept.ownerOrgId}-${area.areaId}`}>
                    {areaIndex === 0 && (
                      <div
                        className={`${styles.cell} ${styles.deptGrid}`}
                        style={{ gridRow: `span ${rowSpan}`, position: 'relative' }}
                      >
                        <span className={styles.deptText}>{dept.ownerOrgName}</span>
                        <div
                          className={styles.bottomLine}
                          style={{ position: 'absolute', bottom: 0, width: '100%' }}
                        ></div>
                      </div>
                    )}
                    <div className={classNames(styles.cell, styles.areaContainer)}>
                      <span className={styles.deptText}>{area.areaName}</span>
                      <div
                        className={styles.bottomLine}
                        style={{ position: 'absolute', bottom: 0, width: '100%' }}
                      ></div>
                    </div>
                    {area.timeDetailVoList.map((date: any, dateIndex: number) => {
                      const key = mediumType + '+' + dept.ownerOrgId + '+' + area.areaId + '+' + date.date;
                      return (
                        <div style={{ display: 'flex' }} className={styles.cell}>
                          <div
                            key={key}
                            style={{
                              flex: 1,
                              maxHeight: '165px',
                              minHeight: '88px',
                              overflowY: 'auto', // 超出高度后显示滚动条
                              backgroundColor:
                                dateSelectIndex.includes(key) && batchOp ? 'rgba(4, 60, 112, 0.2)' : 'inherit',
                              position: 'relative',
                              border: dateSelectIndex.includes(key) && batchOp ? '1px solid #4A90E2' : 'none',
                            }}
                            onClick={() => {
                              setDateSelectIndex(prev => {
                                if (prev.includes(key)) return prev.filter(index => index !== key);
                                else return [...prev, key];
                              });
                            }}
                          >
                            {!batchOp && (
                              <Space size={2} style={{ display: 'flex', justifyContent: 'center' }}>
                                {!isView && (
                                  <Button
                                    type="link"
                                    onClick={e => {
                                      parseTime(key);
                                      setModalVisible(true);
                                      checkTimeSlotConflictMerge([key]);
                                    }}
                                    className={styles.editText}
                                  >
                                    编辑
                                  </Button>
                                )}
                                {!isView && (
                                  <Popconfirm
                                    title="确定要清除吗？"
                                    okText="确认"
                                    cancelText="取消"
                                    onConfirm={() => clear([key])}
                                  >
                                    <Button type="link" className={styles.editText}>
                                      清除
                                    </Button>
                                  </Popconfirm>
                                )}
                              </Space>
                            )}
                            <div
                              className={styles.detailList}
                              style={{
                                alignItems: date.detailList.length === 0 ? 'center' : 'flex-start',
                              }}
                            >
                              {date.detailList.length === 0 ? (
                                <div
                                  className={styles.nullTimeSlot}
                                  style={{ marginTop: batchOp || isView ? '9px' : '0' }}
                                >
                                  暂无配置
                                </div>
                              ) : (
                                date.detailList?.map((timeSlot: any, timeIndex: number) => (
                                  <div
                                    className={styles.timeSlot}
                                    style={{ marginTop: timeIndex === 0 && (batchOp || isView) ? '9px' : '0' }}
                                    key={`${timeIndex}-${timeSlot.startDateTime}-${timeSlot.endDateTime}-${date.date}
                                `}
                                  >
                                    {formatDateTimeRange(timeSlot.startDateTime, timeSlot.endDateTime, date.date)}
                                  </div>
                                ))
                              )}
                            </div>
                            <div
                              className={styles.bottomLine}
                              style={{
                                position: stickyKeys.has(key) ? 'sticky' : 'absolute',
                                bottom: 0,
                                width: '100%',
                              }}
                            ></div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ));
              })
            )
            .flat()}
        </div>
      </div>
    ),
    [filteredData, DateRange, dateSelectIndex, batchOp, isView, stickyKeys]
  );
  return (
    <>
      <Wrapper routes={[...(breadcrumbRoutes?.routes ?? []), ...routes]} className="page_wrapper">
        <FormTitle
          title="用能计划申请"
          extraContent={
            <Space size="small">
              {!isView && (
                <>
                  <Button
                    type="primary"
                    onClick={() => {
                      submit();
                    }}
                  >
                    提交
                  </Button>
                </>
              )}
              <Button onClick={() => navigate('/energy/usage/application')}>返回</Button>
            </Space>
          }
        />
        <Space size="small">
          <Form form={form}>
            <Form.Item name="date" label="申请时间范围" rules={[{ required: true }]}>
              <RangePicker
                allowClear={false}
                disabledDate={(date, info) => disabled7DaysDate(date, info, limitTime)}
                onChange={dateChange}
                disabled={id !== undefined || batchOp}
              />
            </Form.Item>
          </Form>
          <div style={{ marginBottom: '20px' }}>
            <Space size="small">
              {!batchOp ? (
                <>
                  {!isView && (
                    <>
                      <AntdUpload
                        action="/api/v2/energy/consumption/plan/import"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        maxCount={1}
                        showUploadList={false}
                        listType="text"
                        beforeUpload={file => {
                          const isLt20M = file.size / 1024 / 1024 < 20;
                          const isXLSX =
                            file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                          if (!isLt20M) {
                            Modal.warning({
                              content: '上传文件的大小不得超过20M',
                            });
                          }
                          if (!isXLSX) {
                            Modal.warning({
                              content: '文件格式错误!仅支持.xlsx',
                            });
                          }
                          return (isLt20M && isXLSX) || AntdUpload.LIST_IGNORE;
                        }}
                        onChange={info => {
                          const { file, fileList } = info;
                          // file.status 表示当前文件状态：uploading/success/error
                          if (file.status === 'done') {
                            updateDataByUpload(file.response.data.energyConsumptionPlanOfMediumList);
                          }
                        }}
                      >
                        <Button
                          type="primary"
                          icon={<PlusOutlined onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />}
                        >
                          导入
                        </Button>
                      </AntdUpload>
                      <Button
                        type="primary"
                        href={`/api/v2/energy/consumption/plan/template/download?startDate=${dayjs(
                          DateRange[0],
                          'YYYYMMDD'
                        ).valueOf()}&endDate=${dayjs(DateRange[6], 'YYYYMMDD').valueOf()}`}
                        download
                      >
                        下载导入模板
                      </Button>
                      <Button type="primary" onClick={() => setIsCopy(true)}>
                        复制
                      </Button>
                      <Button
                        type="primary"
                        onClick={() =>
                          Modal.confirm({
                            title: '是否清除当前周期范围内能源介质对应的用能计划？清除后将无法恢复。',
                            onOk: () => {
                              // 获取所有 id
                              const allIds: string[] = [];
                              data.forEach((medium: any) => {
                                medium.ownerOrgInfoVoList.forEach((dept: any) => {
                                  dept.areaInfoVoList.forEach((area: any) => {
                                    area.timeDetailVoList.forEach((date: any) => {
                                      allIds.push(`${mediumType}+${dept.ownerOrgId}+${area.areaId}+${date.date}`);
                                    });
                                  });
                                });
                              });
                              clear(allIds);
                              setDateSelectIndex([]);
                            },
                          })
                        }
                      >
                        清除
                      </Button>
                      <Button
                        type="primary"
                        onClick={() => {
                          setBatchOp(!batchOp);
                          setDateSelectIndex([]);
                        }}
                      >
                        批量操作
                      </Button>
                    </>
                  )}
                </>
              ) : (
                <>
                  <Button
                    type="primary"
                    onClick={() => {
                      setModalVisible(true);
                      checkTimeSlotConflictMerge(dateSelectIndex);
                    }}
                  >
                    批量配置时间
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      Modal.confirm({
                        title: '确定批量清除所选范围内的用能计划？',
                        onOk: () => {
                          clear(batchMediumId(dateSelectIndex, batchType));
                        },
                      });
                    }}
                  >
                    批量清除
                  </Button>

                  <Button
                    onClick={() => {
                      setBatchOp(!batchOp);
                    }}
                  >
                    退出批量选择
                  </Button>
                </>
              )}
            </Space>
          </div>
        </Space>

        {!batchOp ? (
          <Tabs
            items={mediumRef.current.map((item: any) => ({
              label: item.energyMediumName,
              key: item.energyMediumId.toString(),
              children: TableBody,
            }))}
            onChange={key => setMediumType(parseInt(key))}
          />
        ) : (
          <>
            <Form>
              <Form.Item label="能源介质" rules={[{ required: true }]}>
                <Checkbox.Group
                  onChange={value => setBatchType(value)}
                  defaultValue={[mediumRef.current[0].energyMediumId]}
                >
                  {mediumRef.current.map((item: any, index: any) => (
                    <Checkbox key={index} value={item.energyMediumId} style={{ marginRight: '20px' }}>
                      {item.energyMediumName}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
              </Form.Item>
            </Form>
            {TableBody}
          </>
        )}
        <Modal
          contentClassName="modal-form-content"
          open={modalVisible}
          size="big"
          title="编辑时段"
          onCancel={() => {
            setModalVisible(false);
          }}
          onOk={() => {
            batchOp ? editTime(batchMediumId(dateSelectIndex, batchType)) : editTime(ExprieceTimeList.ids);
            setModalVisible(false);
          }}
        >
          <TimeSelect
            initExprieceTimeList={ExprieceTimeList}
            setEpr={setExprieceTimeList}
            disabledIntervals={disabledDates}
          />
        </Modal>
        <Modal
          title="复制"
          open={isCopy}
          onOk={() => {
            setData((prevData: any) => copyDetailListFromSourceToTargets(prevData, mediumType, copySelectMedium));
            setIsCopy(false);
          }}
          onCancel={() => setIsCopy(false)}
          size="normal"
        >
          <span style={{ color: 'red', marginLeft: '48px' }}>*</span>
          <span style={{ color: 'rgba(255, 255, 255, 0.5)', width: '56px', marginRight: '30px' }}>能源介质：</span>
          <Select
            allowClear
            mode="multiple"
            options={mediumRef.current
              .filter((item: any) => item.energyMediumId !== mediumType)
              .map((item: any) => ({ label: item.energyMediumName, value: item.energyMediumId }))}
            style={{ width: '360px', marginRight: '48px' }}
            onChange={value => {
              setCopySelectMedium(value);
            }}
          />

          <div style={{ marginTop: '8px' }}>
            <InfoCircleOutlined
              style={{ color: '#FAAD14', marginLeft: '155px', marginTop: '8px' }}
              onPointerEnterCapture={undefined}
              onPointerLeaveCapture={undefined}
            />
            <span className={styles.selectInfoText}>{` 将当前能源介质下的用能计划复制到所选能源介质Tab下`}</span>
          </div>
        </Modal>
      </Wrapper>
    </>
  );
};

export default UsePlanRequistion;
